// ThreeScene.jsx
import React, { useEffect, useRef } from "react"
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, useGLTF } from '@react-three/drei'

function Model() {
  const { scene } = useGLTF('/1glb_optimized.glb')  // <-- path to your 3D model
  const modelRef = useRef()

  useEffect(() => {
    scene.traverse((child) => {
      if (child.isMesh) {
        child.material.color.set('#ff5f8dba') // Teal color
      }
    })
  }, [scene])

  useFrame(() => {
    if (modelRef.current) {
      modelRef.current.rotation.y += 0.01 // rotate around Y-axis
    }
  })

  return <primitive
    ref={modelRef}
    object={scene}
    scale={.02}          // <-- smaller scale
    position={[0, 0, 0]} // <-- move down slightly
    rotation={[0, Math.PI / 4, 0]} // optional rotation
  />
}

const ThreeScene = () => {
  return (
    <Canvas style={{ height: '100vh', width: '100%' }}>
      {/* Camera controls */}
      <OrbitControls enableZoom={false} />

      {/* Lighting */}
      <ambientLight intensity={0.5} />
      <directionalLight position={[5, 5, 5]} intensity={1} />

      {/* The model */}
      <Model />
    </Canvas>
  )
}

export default ThreeScene
